<div class="row">
  <div class="col-sm-12 col-md-12 col-lg-9 col-xl-9 text-start mt-2">
    <div class="row mb-2">
      <div class="col-6 text-start">
        <label class="heading">Booth Rentals</label>
      </div>
      <div class="col-6 text-end">
        <button class="btn btnAS me-1">ADD</button>
        <button class="btn btnAS" *ngIf="!noLayout">Layout</button>
      </div>
    </div>
    <ejs-grid [allowSorting]="true" class="e-grid-custom" Height="350">
      <e-columns>
        <e-column field="BoothNum" headerText="Booth #" width="150"></e-column>
        <e-column field="Res" headerText="Res" width="150"></e-column>
        <e-column field="Drop" headerText="Drop" width="150"></e-column>
        <e-column field="BoothType" headerText="Booth Type" width="150"></e-column>
        <e-column field="Product" headerText="Product" width="250">
          <ng-template #template let-data>
            <select class="form-select"></select>
          </ng-template>
        </e-column>
        <e-column field="Fri" headerText="Fri" width="150"></e-column>
        <e-column field="Sat" headerText="Sat" width="150"></e-column>
        <e-column field="RentalStartDate" headerText="Rental Start Date" width="150"></e-column>
      </e-columns>
    </ejs-grid>
    <div class="row my-2">
      <div class="col-6 text-start">
        <label class="heading">Other Rentals</label>
      </div>
      <div class="col-6 text-end">
        <button class="btn btnAS me-1">ADD</button>
      </div>
    </div>
    <ejs-grid [allowSorting]="true" class="e-grid-custom" Height="350">
      <e-columns>
        <e-column field="Item" headerText="Item" width="250"></e-column>
        <e-column field="Res" headerText="Res" width="150"></e-column>
        <e-column field="Charge" headerText="Charge" textAlign="right" width="200"></e-column>
        <e-column field="Qty" headerText="Qty" width="150"></e-column>
        <e-column field="Month" headerText="Month" width="150"></e-column>
        <e-column field="Total" headerText="Total" textAlign="right" width="200"></e-column>
        <e-column field="Reference" headerText="Reference" width="250"></e-column>
        <e-column field="Delete" headerText="Delete" width="150">
          <ng-template #template let-data>
            <a><img src="./assets/images/delete.svg" class="img-fluid" /></a>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
  <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 text-start mt-2">
    <div class="border rounded p-3 mb-2">
      <div class="row row-cols-2 g-2">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="displayReceipt">
          <label class="form-check-label" for="displayReceipt">Display Receipt</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="displayContract">
          <label class="form-check-label" for="displayContract">Display Contract</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="printReceipt">
          <label class="form-check-label" for="printReceipt">Print Receipt</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="printContract">
          <label class="form-check-label" for="printContract">Print Contract</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="emailReceipt">
          <label class="form-check-label" for="emailReceipt">Email Receipt</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="emailContract">
          <label class="form-check-label" for="emailContract">Email Contract</label>
        </div>
      </div>
    </div>

    <!-- Charges Section -->
    <div class="border rounded p-3">
      <h6 class="fw-bold mb-2">Charges</h6>
      <div class="row g-2 mb-2">
        <div class="col-6">
          <label class="form-label">Prior Balance</label>
          <input type="text" class="form-control text-end">
        </div>
        <div class="col-6">
          <label class="form-label">Rental Charges</label>
          <input type="text" class="form-control text-end">
        </div>
        <div class="col-6">
          <label class="form-label">Other Charges</label>
          <input type="text" class="form-control text-end">
        </div>
        <div class="col-6">
          <label class="form-label">Discount %</label>
          <input type="text" class="form-control">
        </div>
        <div class="col-6">
          <label class="form-label">Sales Tax</label>
          <input type="text" class="form-control text-end">
        </div>
        <div class="col-6">
          <label class="form-label">Sec Level Tax</label>
          <input type="text" class="form-control text-end">
        </div>
      </div>
      <div class="mb-1 fw-bold">TOTAL</div>
      <input type="text" class="form-control text-end">
    </div>

  </div>

</div>